module.exports = __webpack_public_path__ + "static/img/logo.ab47cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 0